<template>
  <div class="container-fluid">
    <div class="row" id="app">

      <!-- Input Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <TopbarNav :pageTitle="'Steel Column Design'" :showHome="true" />
        <hr />


        <div class="row">
          <div class="col-6">Shape</div>
          <div class="col-6">
            <select name="shape" v-model="shape">
              <option value="W">W - Wide Flange</option>
              <option value="HSS">HSS - Hollow Structural Section</option>
              <option value="WT">WT - Structural Tee</option>
              <option value="C">C - Channel</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-6">Section</div>
          <div class="col-6">
            <select name="section" v-model="section">
              <option value="W1100x499">W1100x499</option>
              <option value="W920x446">W920x446</option>
              <option value="W840x329">W840x329</option>
              <option value="W610x241">W610x241</option>
              <option value="W530x150">W530x150</option>
              <option value="W410x85">W410x85</option>
              <option value="W310x52">W310x52</option>
              <option value="W250x33">W250x33</option>
            </select>
          </div>
        </div>
        <hr />

        <!-- Effective Length -->
        <div class="row">
          <div class="col-6">K<sub>x</sub>L<sub>x</sub></div>
          <div class="col-6">
            <input type="number" name="KxLx" v-model="KxLx" /><span>mm (strong axis)</span>
          </div>
        </div>

        <div class="row">
          <div class="col-6">K<sub>y</sub>L<sub>y</sub></div>
          <div class="col-6">
            <input type="number" name="KyLy" v-model="KyLy" /><span>mm (weak axis)</span>
          </div>
        </div>
        <hr />

        <!-- Forces -->
        <div class="row">
          <div class="col-6">Factored Axial Load, C<sub>f</sub></div>
          <div class="col-6">
            <input type="number" name="Cf" v-model="Cf" /><span>kN</span>
          </div>
        </div>
      </div>

      <!-- Report Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <p class="fst-italic">CSA S16-19</p>
        <hr />

        <p><strong>Section Visualization</strong></p>
        <Visualizer :descriptor="visualizationDescriptor" :width="300" :height="300" />
      </div>

    </div>
  </div>
</template>

<script>
import TopbarNav from '@/components/TopbarNav.vue'
import Visualizer from '@/components/Visualizer.vue'

export default {
  name: 'SteelColumn',
  components: { TopbarNav, Visualizer },
  data() {
    return {
      shape: 'W',
      section: 'W1100x499',
      KxLx: 1000,
      KyLy: 1000,
      Cf: 100,
      visualizationDescriptor: [
        [
          { x: -100, y: -100 },
          { x: 100, y: -100 },
          { x: 100, y: 100 },
          { x: -100, y: 100 },
        ],
      ],
    }
  },
  computed: {},
}
</script>
